import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";

interface SOFVerificationPayload {
  physicianId: number | string;
  primaryTest: number | string;
  secondaryTest?: number | string;
}

interface SOFVerificationResponse {
  noSOF?: boolean;
  isExpiredSOF?: boolean;
  sofMismatch?: boolean;
  [key: string]: boolean | undefined;
}

function useVerifySOF() {
  const { authState } = useOktaAuth();

  return useMutation({
    mutationKey: ["verifySOF"],
    mutationFn: (payload: SOFVerificationPayload) => {
      return axiosInstance.post<{ data: SOFVerificationResponse }>(
        "v1/sof/sof-verification",
        payload,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onError: (error: AxiosError<any, any>) => {
      console.error("SOF verification error:", error);
    },
  });
}

export default useVerifySOF;
